import React from "react";

function ConsolidationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <g clip-path="url(#clip0_1383_1619)">
        <path
          d="M7.35742 0.89248C7.76484 0.703809 8.23516 0.703809 8.64258 0.89248L14.6199 3.6542C14.8523 3.76084 15 3.99326 15 4.25029C15 4.50732 14.8523 4.73975 14.6199 4.84639L8.64258 7.60811C8.23516 7.79678 7.76484 7.79678 7.35742 7.60811L1.38008 4.84639C1.14766 4.73701 1 4.50459 1 4.25029C1 3.996 1.14766 3.76084 1.38008 3.6542L7.35742 0.89248ZM13.1652 6.48154L14.6199 7.1542C14.8523 7.26084 15 7.49326 15 7.75029C15 8.00732 14.8523 8.23975 14.6199 8.34639L8.64258 11.1081C8.23516 11.2968 7.76484 11.2968 7.35742 11.1081L1.38008 8.34639C1.14766 8.23701 1 8.00459 1 7.75029C1 7.496 1.14766 7.26084 1.38008 7.1542L2.83477 6.48154L6.99102 8.40107C7.63086 8.69639 8.36914 8.69639 9.00898 8.40107L13.1652 6.48154ZM9.00898 11.9011L13.1652 9.98154L14.6199 10.6542C14.8523 10.7608 15 10.9933 15 11.2503C15 11.5073 14.8523 11.7397 14.6199 11.8464L8.64258 14.6081C8.23516 14.7968 7.76484 14.7968 7.35742 14.6081L1.38008 11.8464C1.14766 11.737 1 11.5046 1 11.2503C1 10.996 1.14766 10.7608 1.38008 10.6542L2.83477 9.98154L6.99102 11.9011C7.63086 12.1964 8.36914 12.1964 9.00898 11.9011Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1383_1619">
          <path d="M0.125 0.75H15.875V14.75H0.125V0.75Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ConsolidationIcon;
